module.exports = __webpack_public_path__ + "static/img/Six of Swords.55e6161.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Six of Swords.jpg
// module id = 1301
// module chunks = 0